import { capitalize, Stack } from '@mui/material'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { VailAccordion, VailSelect, VailTextField } from '@/components'
import { ComponentType } from '@/utils/api'

import WorkshopTitlePreview from './WorkshopTitlePreview'

export type BasicCustomComponentSettingsProps = {
  componentType: keyof typeof ComponentType
}

export const BasicCustomComponentSettings = (
  props: BasicCustomComponentSettingsProps
) => {
  const form = useFormContext()
  const { setValue } = form
  useEffect(() => {
    setValue('type', props.componentType)
  }, [props.componentType, setValue])
  return (
    <VailAccordion
      defaultExpanded
      useDefaultBox
      detailsSx={{
        display: 'flex',
        flexDirection: ['column', null, 'row'],
        gap: 2,
      }}
      title="Description"
    >
      <Stack flex={1} gap={2}>
        <VailTextField label="Name" name="name" />
        <WorkshopTitlePreview name={form.watch('name')} />
        <VailSelect
          disabled
          defaultValue={props.componentType}
          label="Type"
          name="type"
          options={[
            {
              label: capitalize(props.componentType),
              value: props.componentType,
            },
          ]}
        />
      </Stack>
      <Stack flex={1}>
        <VailTextField
          multiline
          label="Description"
          maxRows={10}
          minRows={4}
          name="description"
          rules={{ required: false }}
        />
      </Stack>
    </VailAccordion>
  )
}
